/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiSanctionRecordRole } from './ApiSanctionRecordRole';
import {
    ApiSanctionRecordRoleFromJSON,
    ApiSanctionRecordRoleFromJSONTyped,
    ApiSanctionRecordRoleToJSON,
    ApiSanctionRecordRoleToJSONTyped,
} from './ApiSanctionRecordRole';

/**
 * 
 * @export
 * @interface ApiAssociationDetails
 */
export interface ApiAssociationDetails {
    /**
     * 
     * @type {string}
     * @memberof ApiAssociationDetails
     */
    associateId: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAssociationDetails
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAssociationDetails
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAssociationDetails
     */
    relationship: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAssociationDetails
     */
    ex: boolean;
    /**
     * 
     * @type {Array<ApiSanctionRecordRole>}
     * @memberof ApiAssociationDetails
     */
    roles: Array<ApiSanctionRecordRole>;
}

/**
 * Check if a given object implements the ApiAssociationDetails interface.
 */
export function instanceOfApiAssociationDetails(value: object): value is ApiAssociationDetails {
    if (!('associateId' in value) || value['associateId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('relationship' in value) || value['relationship'] === undefined) return false;
    if (!('ex' in value) || value['ex'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function ApiAssociationDetailsFromJSON(json: any): ApiAssociationDetails {
    return ApiAssociationDetailsFromJSONTyped(json, false);
}

export function ApiAssociationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAssociationDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'associateId': json['associateId'],
        'type': json['type'],
        'name': json['name'],
        'relationship': json['relationship'],
        'ex': json['ex'],
        'roles': ((json['roles'] as Array<any>).map(ApiSanctionRecordRoleFromJSON)),
    };
}

export function ApiAssociationDetailsToJSON(json: any): ApiAssociationDetails {
    return ApiAssociationDetailsToJSONTyped(json, false);
}

export function ApiAssociationDetailsToJSONTyped(value?: ApiAssociationDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'associateId': value['associateId'],
        'type': value['type'],
        'name': value['name'],
        'relationship': value['relationship'],
        'ex': value['ex'],
        'roles': ((value['roles'] as Array<any>).map(ApiSanctionRecordRoleToJSON)),
    };
}

